<template>
<div class="conteudo-sistema">

    <div class="fl-cabecalho">

        <div class="row animated slideInDown">
            <div class="col-9 form-group">
                <h4 class="animated slideInDown "><fa-icon icon="globe-americas" /> Servidores de Envio</h4>
            </div>

        </div>

        <div class="row animated slideInDown">
            <div class="col-lg-4 col-12 col-xs-12 form-group">
				<flFind @key-up="(inputText) => $refs.table.filtraLista(inputText)"
						placeholder="Buscar"/>
            </div>

            <div class="col-12 col-xs-12 col-lg-2 form-group">
                <button v-if="_getPrivilegio(15)" @click="clickModal(null)" class="btn btn-sm btn-block btn-outline-dark">
                    <fa-icon icon="plus"/> Novo
                </button>
            </div>
        </div>

    </div>

    <flCarregando style="margin-top:20px" v-if="load" />

	<fl-table v-show="!load"
				ref="table"
				class="animated fadeIn fast"
				:perPage="10"
				@click-editar="clickModal"
				@click-excluir="clickExcluir"
				columnStartSortable="tipo"
				:columns="geraCabecalhos()" />

    <flModal @modal-hide="showForm = false" ref="modalCadastro" width="50%">
		<template v-slot:header>
			<span v-if="editar"><fa-icon icon="pen-alt"/> Editar</span>
			<span v-if="!editar"><fa-icon icon="plus"/> Novo</span>
		</template>
        <flCadastro v-if="showForm" ref="cadastro" @item-salvo="atualizaItem" />
    </flModal>
</div>
</template>

<script>
import flCadastro from './cadastro.vue'
import flTable from '../../components/table/main.vue'
import flModal from '../../components/modal/main.vue'
import flCarregando from '../../components/carregando/main.vue'
import axios from '../../routers/axios'
import flFind from '../../components/find/main.vue'
export default {

    components: {
		flCadastro,
		flTable,
		flModal,
		flCarregando,
		flFind
    },

    data(){
        return {
			load: true,
			showForm: false,
			editar: false,
        }
    },

    mounted () {
        this.carregaDados();
    },

    methods: {

        atualizaItem(item){

			item = this.geraColunas(item)
			this.$notify.show('success','Servidor de envio salvo.')
			this.$refs.table.atualizaItem(item, 'id', item._object.id)
			this.exibeCadastro = false
			this.$refs.modalCadastro.hide()
        },

        clickModal(item){

			this.editar = item ? true : false
			this.showForm = true
			this.$refs.modalCadastro.show()
			this.$nextTick(() => {
                if(item != null) this.$refs.cadastro.editar(item._object)
			})
        },

        clickExcluir(item){

			let text = `<h4>Deseja excluir esse servidor de envio?</h4>
						<br>
						<p class="text-danger">
							${item._object.descricao}
							<br/><br/>ATENÇÃO!<br/>
							SERÁ REMOVIDO DE TODOS OS EQUIPAMENTOS
						</p>`

			this.$modalExcluir.show(text, item._object).then(item => {
				this.excluir(item)
			})
        },

        excluir(item){

            this.$notify.loadIn('Excluindo')

            axios.delete(this._getUrl('api/servidorenvio/' + item.id)).then(response => {
				this.$notify.show('success','Servidor excluído.')
				this.$refs.table.excluirItem(item, 'id', item.id)
            })
        },

        carregaDados(){
            this.load = true
            axios.get(this._getUrl('api/servidorenvio')).then(response => {
                this.load = false
				let list = response.data.map(item => { return this.geraColunas(item) })
				this.$refs.table.loadTable(list)
            })
		},

		geraColunas(item){

			let itemLista = {}
			let columns = []


			// tipo
			columns.push({
				html : `<strong>${item.tipo}</strong>`,
				class: item.tipo == 'Produção' ? 'text-primary' : (item.tipo == 'Homologação' ? 'text-info' : 'text-secondary'),
			})

			// descricao
			columns.push({
				html : `${item.descricao} <br/><small class="${item.ativo ? "text-success" : "text-danger"} ">${item.ativo ? "ATIVO" : "DESATIVADO"}</small>`
			})

			// descricao
			columns.push({
				html : `<span class="badge badge-primary">Posição</span> ${item.urlPosicao} <br/>
						<span class="badge badge-dark">Mensagem</span> ${item.urlMensagem} <br/>
						<span class="badge badge-secondary">Trecho</span> ${item.urlTrecho} <br/>
						<span v-if="item.urlAbastecimento" class="badge badge-secondary">Abastecimento</span> ${item.urlAbastecimento} <br/>
						<span v-if="item.urlManutencao" class="badge badge-secondary">Manutenção</span> ${item.urlManutencao}`
			})

			columns.push({
				class: 'text-center',
				clickable: true,
				event: 'click-excluir',
				icon: ["far", "trash-alt"],
				styleIcon: 'font-size: 0.9rem',
				style: 'color: red'
			})

			columns.push({
				class: 'text-center',
				clickable: true,
				event: 'click-editar',
				icon: ["fa", "pen-alt"],
				styleIcon: 'font-size: 0.9rem',
			})


			itemLista._object = item
			itemLista.columns = columns
			return itemLista
		},

		geraCabecalhos(){

			let columns = []

			columns.push({
				name: 'Tipo',
				key: 'tipo',
				searchable: true,
				sortable: true,
				class: '',
				width: '14%',
			})

			columns.push({
				name: 'Descrição',
				key: 'descricao',
				searchable: true,
				sortable: true,
				class: '',
				width: '20%',
			})

			columns.push({
				name: 'URLs',
				key: 'urls',
				width: '60%',
			})

			columns.push({
				name: 'Excluir',
				key: 'excluir',
				class: 'text-center',
				width: '10%',
			})

			columns.push({
				name: 'Editar',
				key: 'editar',
				class: 'text-center',
				width: '10%',
			})

			return columns
		},
    },
}
</script>



// WEBPACK FOOTER //
// src/views/servidor-envio/main.vue